import { Grid, Typography } from "@mui/material";
import type { FC } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import PublicOrderParticipantLists from "../orders/participantLists/PublicOrderParticipantLists";

const PublicParticipantListsPage: FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token")?.trim() ?? "";

  if (!orderId || !token) {
    return (
      <Grid
        container
        sx={{
          marginTop: 2,
          marginBottom: 2,
        }}
      >
        <Typography variant="h6">Link jest niepełny lub wygasł</Typography>
        <Typography
          variant="body2"
          sx={{
            marginTop: 1,
          }}
        >
          Skontaktuj się z biurem podróży, aby otrzymać poprawny link do listy uczestników.
        </Typography>
      </Grid>
    );
  }

  return <PublicOrderParticipantLists signedLinkToken={token} />;
};

export default PublicParticipantListsPage;
